import { render, staticRenderFns } from "./Depositos.vue?vue&type=template&id=6fac0110"
import script from "./Depositos.vue?vue&type=script&lang=js"
export * from "./Depositos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports